import React, { useCallback } from 'react';
import { Card } from '../ui/card';
import { testimonials } from '../../mock';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';

const SDTestimonialsSlider = () => {
  const [emblaRef] = useEmblaCarousel({ 
    loop: true, align: 'start', slidesToScroll: 1, duration: 45
  }, [Autoplay({ delay: 3000, stopOnInteraction: false })]);

  return (
    <section className="py-20 bg-white" data-testid="sd-testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter text-center mb-12">What Our Clients Say</h2>
        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-6">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="flex-[0_0_100%] md:flex-[0_0_calc(50%-12px)] lg:flex-[0_0_calc(33.333%-16px)] min-w-0">
                <Card className="p-6 h-full" data-testid={`testimonial-card-${testimonial.id}`} style={{ marginLeft: testimonial.id === 1 ? '24px' : '0' }}>
                  <p className="text-gray-700 mb-6 italic leading-relaxed">"{testimonial.content}"</p>
                  <div className="flex items-center space-x-4 mt-auto">
                    <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-[#C85A40]" />
                    <div>
                      <h4 className="font-semibold text-[#1A3628]">{testimonial.name}</h4>
                      <p className="text-sm text-gray-600">{testimonial.role}</p>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SDTestimonialsSlider;
